var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",staticClass:"navbar",attrs:{"id":"app"}},[_c('notice-bar',{ref:"notification"}),_c('audio',{ref:"audio",attrs:{"preload":"metadata","hidden":"","src":require("@/audio/notify1.mp3")}}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }